module.exports = __webpack_public_path__ + "static/media/Frame.09a2a96d.svg";